module.exports = __webpack_public_path__ + "static/media/video-05-ru.3d7a0dce.webm";